module.exports = __webpack_public_path__ + "static/media/ic_rentger.851976e4.png";